import type * as React from "react"
import { Button } from "./button"
import { ChevronDownIcon } from "../../icons/chevron-down"
import { cn } from "../../lib/utils"

type PopupActionButtonProps = Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children"> & {
  /** Whether the popup the button controls is open; it turns the default chevron upside down. Set it from the popup's open state. */
  open?: boolean
  /** Replaces the default chevron-down icon. Shown at 16px. */
  icon?: React.ReactNode
}

/** Visual trigger shared by popup controls and embedded cell presentations.
 * The host owns popup state and supplies trigger semantics through render props.
 */
function PopupActionButton({ open, icon, className, shape = "rounded", ...props }: PopupActionButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      shape={shape}
      data-popup-open={open ? "" : undefined}
      className={cn(
        "group/popup-expander max-w-11 data-popup-open:!bg-transparent data-pressed:!bg-transparent",
        className
      )}
      {...props}
    >
      {icon ? (
        <span className="pointer-events-none flex size-4 items-center justify-center text-[var(--fl-color-content-default-secondary)] [&>svg]:size-4">
          {icon}
        </span>
      ) : (
        <ChevronDownIcon className="pointer-events-none size-4 text-[var(--fl-color-content-default-secondary)] transition-transform group-data-[popup-open]/popup-expander:rotate-180" />
      )}
    </Button>
  )
}

export { PopupActionButton }
